import styled from "@emotion/styled";
import { animated } from "@react-spring/web";
import { hexToRGBA } from "../../utils";
import {
  BOTTOM_SHEET_BORDER_RADIUS,
  BOTTOM_SHEET_Z_INDEX,
} from "../../utils/constants";
import { mainColors, colorPalette } from "../../theme/colors";

export const Wrapper = styled.div`
  position: relative;
  z-index: ${BOTTOM_SHEET_Z_INDEX};
`;

export const Overlay = styled(animated.div)`
  position: fixed;
  top: -60px;
  right: 0px;
  left: 0px;
  bottom: -60px;
  background-color: ${hexToRGBA(mainColors.black, 0.9)};
  touch-action: none;
  z-index: 5;
  /* Add these properties for better mobile touch handling */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  /* Ensure overlay blocks all pointer events on mobile */
  pointer-events: auto;
  /* Prevent any touch events from reaching background */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const Sheet = styled(animated.div)`
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scrollbar-width: none;
  // border-radius: ${() => BOTTOM_SHEET_BORDER_RADIUS};
  flex: 1; /* Allow it to take available space */
  display: flex; /* Use flexbox to make content take full space */
  flex-direction: column; /* Stack children vertically */
  touch-action: pan-y; // Allow vertical touch actions
  -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS
  &::-webkit-scrollbar {
    width: 0px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
`;

export const CardCustom = styled(animated.div)<{
  $maxHeight: string;
  $noGutter?: boolean;
}>`
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  width: 100%;
  height: auto; /* Let it adjust based on content */
  max-height: ${(p) => p.$maxHeight};
  z-index: 6;
  touch-action: none;
  border-top-left-radius: ${() => BOTTOM_SHEET_BORDER_RADIUS};
  border-top-right-radius: ${() => BOTTOM_SHEET_BORDER_RADIUS};
  padding: ${(p) => (p.$noGutter ? "26px 0 16px 0" : "26px 20px 16px 20px")};
  max-width: 448px;
  overflow: hidden; /* Contain the overflow within the card */
`;

export const Card = styled(CardCustom)<{
  $sheetShadowColor?: string;
  $maxHeight: string;
  $bgColor?: string;
}>`
  max-height: ${(p) => p.$maxHeight};
  background-color: ${(p) => p.$bgColor || colorPalette.popWhite[400]};
`;

export const Notch = styled.div`
  position: absolute;
  top: 10px;
  width: 32px;
  height: 4px;
  border-radius: 2px;
  background-color: ${colorPalette.popBlack[100]};
  left: 50%;
  transform: translate(-50%, 0);
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;

  &::after,
  &::before {
    content: " ";
    clear: both;
    display: table;
  }
`;
export const GapFiller = styled(animated.div)`
  background-color: ${colorPalette.popWhite[400]};
  height: 1px;
  display: block;
  transform-origin: bottom;
  z-index: 10;
  overscroll-behavior: none;
  touch-action: none;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
`;
